export default __webpack_public_path__ + "static/media/icon-lock.9978293e.svg";